class MainSearch extends SearchForm {
  constructor() {
    super();
    // Encuentra todos los inputs de búsqueda en el documento.
    this.allSearchInputs = document.querySelectorAll('input[type="search"], input[name="q"]');
    // Asume que 'this.input' (del padre) es el principal, o toma el primero.
    if (!this.input) {
      this.input = this.allSearchInputs[0];
    }
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    
    // 1. Evento de Focus (UX para móviles)
    this.input.addEventListener('focus', this.onInputFocus.bind(this));

    // 2. Eventos de Sincronización (Input y Reset)
    if (allSearchForms.length >= 1) { // Cambiado de 2 a 1, más seguro
      // Agregamos el listener de submit a CADA formulario asociado.
      allSearchForms.forEach((form) => {
        // Interceptamos el envío del formulario para usar nuestra lógica avanzada.
        form.addEventListener('submit', this.onFormSubmit.bind(this)); 
        form.addEventListener('reset', this.onFormReset.bind(this));
      });
      // Sincroniza la escritura en todos los campos
      this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    const targetInput = event.target.querySelector('input[type="search"], input[name="q"]');
    if (targetInput) {
      this.handleSearch(targetInput.value);
    }
  }

  // --- Lógica de Búsqueda Avanzada (Adaptada de custom search.js) ---

  async handleSearch(query) {
    if (!query) return;

    // Nota: El 'custom search.js' eliminaba los espacios y pasaba a mayúsculas. Mantenemos esto.
    const cleanQuery = query.replace(/\s+/g, "").toUpperCase();
    const originalQuery = query; // Guardamos la query original para la URL de Shopify
    
    // Si no hay 'cleanQuery' (ej. solo eran espacios), enviamos al search normal de Shopify.
    if (!cleanQuery) {
        window.location.href = `/search?q=${originalQuery}`;
        return;
    }

    try {
      // Usamos el endpoint JSON de Shopify.
      const response = await fetch(`/search?q=${cleanQuery}&view=json`);
      const data = await response.json();

      if (!data.results || data.results.length === 0) {
        // Si no hay resultados de la búsqueda, continuamos con el flujo normal de Shopify.
        window.location.href = `/search?q=${originalQuery}`;
        return;
      }

      const matches = data.results.filter(product => {
        // 1. Búsqueda por TAGS (Lógica original de equivalentes)
        const hasTagMatch = Array.isArray(product.tags) && 
            product.tags.map(tag => tag.toUpperCase()).includes(`EQUIV:${cleanQuery}`);
        
        // 2. Búsqueda por TÍTULO (Nueva lógica solicitada)
        const hasTitleMatch = product.title && 
            product.title.toUpperCase().includes(cleanQuery); 

        return hasTagMatch || hasTitleMatch;
      });

      if (matches.length === 1) {
        // 🚀 Solo un resultado coincidente: Redirigir inmediatamente.
        window.location.href = matches[0].url;
        return;
      } 
      
      if (matches.length > 1) {
         // 🚨 Múltiples equivalentes: Continuar el flujo normal de búsqueda y luego inyectar.
        
        // Ejecuta el envío de formulario estándar de Shopify *antes* de esperar
        // para asegurar que la página de resultados cargue.
        window.location.href = `/search?q=${originalQuery}`;

        // NOTA: La inyección de equivalentes por MutationObserver es compleja.
        // Se necesita un script *adicional* en la página de resultados de búsqueda 
        // que revise el localStorage o un parámetro URL para saber si debe ejecutar
        // la lógica de inyección (ya que la página se recargará con la URL de Shopify).
        
        // **Para simplificar la UNIFICACIÓN de este CÓDIGO en una SOLA PÁGINA:**
        // Si la página *actual* ya es la de resultados (search), inyectamos:
        if (window.location.pathname.includes('/search')) {
            this.injectEquivalents(matches, cleanQuery);
        }
        return; // Salimos después de redirigir/inyectar
      }

      // Si no hubo matches de 'EQUIV' o TÍTULO, enviamos la búsqueda normal.
      window.location.href = `/search?q=${originalQuery}`;
      
    } catch (error) {
      console.error("Error en búsqueda de equivalencias:", error);
      // En caso de error, siempre volvemos al comportamiento estándar de Shopify.
      window.location.href = `/search?q=${originalQuery}`;
    }
  }

  injectEquivalents(matches, cleanQuery) {
    const targetNode = document.querySelector("main") || document.body;
    
    const insertEquivalents = () => {
      // Lógica de creación e inyección de la sección "Productos equivalentes"
      const oldSection = document.getElementById("equivalents-section");
      if (oldSection) oldSection.remove();

      const container = document.createElement("div");
      container.id = "equivalents-section";
      // Usar estilos de tu tema si es posible, si no, los inline están bien
      container.style.cssText = "max-width: 900px; margin: 30px auto; padding: 15px; border: 1px solid #ddd; background-color: #f9f9f9;";

      const title = document.createElement("h2");
      title.textContent = `Productos relevantes o equivalentes para ${cleanQuery}:`;
      container.appendChild(title);

      const ul = document.createElement("ul");
      ul.style.cssText = "list-style: none; padding: 0;";

      matches.forEach(product => {
        const li = document.createElement("li");
        li.style.margin = "10px 0";

        const a = document.createElement("a");
        a.href = product.url;
        a.textContent = product.title;
        a.style.cssText = "text-decoration: none; color: #007aff;";

        li.appendChild(a);
        ul.appendChild(li);
      });

      container.appendChild(ul);
      targetNode.insertBefore(container, targetNode.firstChild);
    };

    // Crear observer para detectar cambios en el DOM de la página de resultados.
    const observer = new MutationObserver((mutationsList, observer) => {
      // Esperamos a que haya al menos un producto cargado
      const resultsExist = targetNode.querySelector(".product-grid, .grid__item, .search-results__item");
      if (resultsExist) {
        insertEquivalents();
        observer.disconnect(); 
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }

  // --- Métodos de UX y Sincronización (Originales) ---

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      // El scrollIntoView es un método de los elementos personalizados (Custom Elements)
      this.scrollIntoView({ behavior: 'smooth' }); 
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

// Asegúrate de que este es el tag correcto usado en tu tema.
customElements.define('main-search', MainSearch);